import { render, staticRenderFns } from "./restorePriceBackup.vue?vue&type=template&id=351dc838&scoped=true"
import script from "./restorePriceBackup.vue?vue&type=script&lang=js"
export * from "./restorePriceBackup.vue?vue&type=script&lang=js"
import style0 from "./restorePriceBackup.vue?vue&type=style&index=0&id=351dc838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351dc838",
  null
  
)

export default component.exports